// extracted by mini-css-extract-plugin
export default {"cls1":"UserCard-cls1_J0y","cls2":"UserCard-cls2_ooH UserCard-cls1_J0y"};